export default {
  username: 'Makler1',
  vmnr: '99998',
  rabattvollmacht: "0",
  tarifname: "basis",
  authorization: {
    roles: [],
    rights: [
      // { name: "TARIFSELECTION", value: "1" },
      // { name: "KEINEANGEBOTSLISTE", value: "1" },
      // { name: "WEBIDSCHWEB", value: "[]" },
      // { name: "VMNRVERTRAG", value: "[]" },
      // { name: "VMNRPROVISION", value: "[]" },
      // { name: "KEINEXCEL", value: "1" },
      // { name: "HIDEBENUTZERDATEN", value: "1" },
      // { name: "OEKOPUNKTE", value: "1" },
      // { name: "MAKNUMMER", value: "1" },
    ]
  },
  metadata: {
    title: "",
    firstname: "Test",
    lastname: "Makler - normal",
    company: ""
  }
};
